module.exports = __webpack_public_path__ + "static/media/estadoCritico.a1427613.svg";